import { render, staticRenderFns } from "./ExclamationRectangle.vue?vue&type=template&id=7664f389&"
import script from "./ExclamationRectangle.vue?vue&type=script&lang=js&"
export * from "./ExclamationRectangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports